import React, { useEffect, useRef, useState } from 'react';
import './Stats.css';

const Stats = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState({ projects: 0, clients: 0, satisfaction: 0, years: 0 });
  const statsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isVisible) {
      const targets = { projects: 150, clients: 50, satisfaction: 98, years: 5 };
      const duration = 2000;
      const steps = 60;
      const interval = duration / steps;

      const timer = setInterval(() => {
        setCounts(prev => {
          const newCounts = {};
          let allComplete = true;

          Object.keys(targets).forEach(key => {
            if (prev[key] < targets[key]) {
              newCounts[key] = Math.min(prev[key] + Math.ceil(targets[key] / steps), targets[key]);
              allComplete = false;
            } else {
              newCounts[key] = targets[key];
            }
          });

          if (allComplete) {
            clearInterval(timer);
          }

          return newCounts;
        });
      }, interval);

      return () => clearInterval(timer);
    }
  }, [isVisible]);

  return (
    <section className="stats-section" ref={statsRef}>
      <div className="stats-container">
        <div className={`stats-grid ${isVisible ? 'visible' : ''}`}>
          <div className="stat-box">
            <div className="stat-icon">🚀</div>
            <h3 className="stat-number">{counts.projects}+</h3>
            <p className="stat-label">Projects Completed</p>
          </div>
          <div className="stat-box">
            <div className="stat-icon">🤝</div>
            <h3 className="stat-number">{counts.clients}+</h3>
            <p className="stat-label">Happy Clients</p>
          </div>
          <div className="stat-box">
            <div className="stat-icon">⭐</div>
            <h3 className="stat-number">{counts.satisfaction}%</h3>
            <p className="stat-label">Satisfaction Rate</p>
          </div>
          <div className="stat-box">
            <div className="stat-icon">📅</div>
            <h3 className="stat-number">{counts.years}+</h3>
            <p className="stat-label">Years Experience</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
